"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../../graphql");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const hooks_1 = require("../../../../hooks");
exports.LOGOUT_BUTTON_ID = 'logout-button';
exports.LogoutDropdownItem = ({ onLogout }) => {
    const { updateOsmosysContext } = hooks_1.useOsmosysUpdate();
    const { currentUser, loadApp: { refetch }, } = hooks_1.useOsmosysContext();
    const [mutate, { loading, error }] = react_hooks_1.useMutation(graphql_1.logout, {
        onCompleted: () => {
            if (refetch) {
                updateOsmosysContext({
                    currentUser: null,
                });
                refetch();
            }
            onLogout();
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.DropdownItem, { "data-cy": "app-nav-menu-logout", tag: react_2.OsmosysDiv, href: loading ? undefined : '#', asLink: !loading, osysName: "LogoutDropdownItem", id: exports.LOGOUT_BUTTON_ID, className: "text-center", onClick: e => {
                e.preventDefault();
                mutate();
            }, disabled: !currentUser },
            loading ? '' : 'Log out',
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "ml-2", icon: loading ? pro_regular_svg_icons_1.faSpinnerThird : pro_solid_svg_icons_1.faSignOutAlt, spin: loading, fixedWidth: true })),
        react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: error, resource: "Session", action: "delete" })));
};
//# sourceMappingURL=LogoutDropdownItem.js.map